import React, { ReactNode, useEffect, useState } from 'react';
import { ModalView } from './Modal.view';
import useStyle from './modal.style';

export interface ModalProps {
  modalHead: string;
  children: ReactNode | ReactNode[];
  isShowingDefault?: boolean;
  width?: 'small' | 'medium' | 'cover' | 'laptop';
  onCloseAction?: () => void;
  blockClose?: boolean;
  onBlockCloseAction?: () => void;
  triggerButton?: React.ReactNode;
  triggerButtonStyle?: 'default' | 'ChallengeModal';
  actionButton?: React.ReactNode;
}

export const Modal = ({
  children,
  modalHead,
  isShowingDefault = false,
  width,
  onCloseAction,
  blockClose = false,
  onBlockCloseAction,
  triggerButton,
  triggerButtonStyle = 'default',
  actionButton
}: ModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const classes = useStyle();
  useEffect(() => {
    isShowingDefault && setIsOpen(true);
  }, [isShowingDefault]);

  const onClose = () => {
    if (!blockClose) {
      setIsOpen(false);
      onCloseAction && onCloseAction();
    } else {
      onBlockCloseAction && onBlockCloseAction();
    }
  };

  return (
    <>
      {triggerButton && (
        <div
          onClick={() => {
            setIsOpen(true);
          }}
          className={
            triggerButtonStyle === 'ChallengeModal'
              ? classes.buttonModalChallenge
              : null
          }
        >
          {triggerButton}
        </div>
      )}
      <ModalView
        modalHead={modalHead}
        isShowing={isOpen}
        onClose={onClose}
        width={width}
        actionButton={actionButton}
      >
        {children}
      </ModalView>
    </>
  );
};
